<template>
  <div class="online-course">
    <Header />
    <div v-if="false" class="content" style="margin-top: 50px !important">
      <div class="training_course">
        <div class="card">
        </div>
      </div>
    </div>
    <div class="content" style="margin-top: 50px !important">
      <div class="couser-module">
        <div>
          <div class="rich_box">
            <div class=" ">
              <div class="welfare_publicity">
                <div style="margin-top: 50px" v-if="!courseIntroductionInfo"
                  class="welfare_box training_course nocourse flex flex-row flex-algin-center flex-jus-center flex-nowarp">
                  <div class="flex flex-column flex-algin-center flex-jus-center flex-nowarp">
                    <!-- <img src="@/assets/Nocourses.png" alt="" />
                    <div class='nothing-view'><span class="emptyText"> 啊喔，暂时还没有简介 </span></div> -->
                  </div>
                </div>
                <div v-else class="" v-html="courseIntroductionInfo"></div>
              </div>
              <!-- <div v-if="false" class="item" v-for="(item, index) in courseList" :key="index"
                @click="getCourseDetail(item)">
                <img :src="item.cover" class="item-img" />
                <div class="title-view">
                  <div class="img-title">{{ item.title }}</div>
                  <div class="img-title">{{ item.expertName }}</div>
                </div>
              </div> -->
            </div>

          </div>
          <div class="flex flex-column flex-algin-center flex-jus-center flex-nowarp">
            <!-- <el-pagination v-if="false" background layout="prev, pager, next" :total="totalCount"
              @current-change="changePage" class="pagination" prev-text="上一页" :page-size="12" next-text="下一页">
            </el-pagination> -->
            <div class="goSignUpClassInsort flex flex-row flex-algin-center flex-jus-center flex-nowarp">
              <div class="goSignUpClass" @click="goToSignUpFun">
                注册账号
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  components: { Header, Footer },
  name: "onlineCourse",
  data() {
    return {
      totalCount: 0,
      courseList: [],
      coursePage: 1,
      courseIntroductionInfo:'',// 课程介绍
      subjectCode:''
    };
  },
  watch: {
    '$route': {
      handler(newRoute, oldRoute) {
       
        if (oldRoute && newRoute.query.subjectCode  !== oldRoute.query.subjectCode) {
          this.getInstance(newRoute.query)
        }
       
      },
      deep: true,
      immediate: true
    },
  },

  methods: {
    getInstance(query) {
      var that = this;
      this.$http({
        url: that.webhost + `guide/getKcjs`,
        method: "GET",
        params:{
          subjectId:query.subjectCode
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.courseIntroductionInfo = data.data;
        }
      }).catch(error => {
        console.error('请求失败:', error);
      });
    },
    // 跳转报名页面
    async goToSignUpFun() {
      
      this.$router.push(
        `/onlineRegistration?subjectCode=${this.subjectCode}`)
 


    },
    // 通过传固定值‘01’表示代缴费来判断跳转注册页面的第几步
    // async isHaveIntoPayFun(item) {
    //   const res = await isPayRegsitApi({
    //     categoryId: item.id,
    //   });
    //   console.log("res23", res);
    //   return res;
    // },
    // 页数修改
    changePage(even) {
      this.coursePage = even;
      this.getcourseList(this.categoryCode);
    },
    // 培训认证菜单list
    // async getTrainingCertificationListFun() {
    //   const res = await professionalClassificationApi("02");
    //   if (res.code == 0) {
    //     // res.result.splice(2, 4)
    //     // this.sortTypeList = res.result.splice(2);
    //     let itemArr = []
    //     res.result.forEach((item,index)=>{
    //       if( item.categoryName != '我的课程' && item.categoryName != '我的习题'){
    //         itemArr.push(item)
    //       }
    //     })
    //     this.sortTypeList = itemArr;
    //     if (!this.$route.query.publicProssId) {
    //       this.currentIndex = this.sortTypeList[0].categoryCode;
    //       this.categoryCode = this.sortTypeList[0].categoryCode;
    //       this.selectIndex = 0;
    //       // this.getcourseList(this.categoryCode);
    //     }
    //   }
    // },
    // 课程列表接口
    // getcourseList() {
    //   getOnlineRegistSecondMenuApi({
    //     categoryCode,
    //     page: this.coursePage,
    //     size: 12,
    //   }).then((res) => {
    //     console.log("课程列表", res);
    //     this.totalCount = res.result.totalCount;
    //     if (res.code == 0) {
    //       this.courseList = res.result.list;
    //     }
    //     console.log("有无课程", this.course);
    //   });
    // },
    //跳转视频详情
    // async getCourseDetail(item) {
    //   this.$router.push(
    //     `/onlineRegistration?
    //         onlineRegistObj=${encodeURI(
    //       JSON.stringify(item)
    //     )}`
    //   );
    //   const res = await this.isHaveIntoPayFun(item);
    //   if (res.code == 0) {
    //   if (res.result.totalCount > 0) {
    //     this.$router.push(
    //       `/onlineRegistration?progress=${
    //         res.result.list[0].progress
    //       }&onlineRegistObj=${encodeURI(
    //         JSON.stringify(item)
    //       )}&onlineRegistObj2=${encodeURI(
    //         JSON.stringify(res.result.list[0])
    //       )}`
    //     );
    //   } else if (res.result.totalCount == 0) {
    //     this.$router.push(
    //       `/onlineRegistration?onlineRegistObj=${encodeURI(
    //         JSON.stringify(item)
    //       )}&onlineRegistObj2=${encodeURI(
    //         JSON.stringify(res.result.list[0])
    //       )}`
    //     );
    //   }
    //   } else {
    //     this.$message(res.msg);
    //   }
    // },
    handleExercises() {
      this.$router.push(`/trainingExercises`);
    },
  },
  mounted() {
        this.$store.state.tab = '职称继教'
    const query = this.$route.query;
    this.subjectCode = query.subjectCode || query.code;
    this.getInstance(query);
 
  },
  created() {
    // if (this.$route.query.publicProssId) {
    //   this.currentIndex = this.$route.query.publicProssId;
    //   this.getcourseList(this.$route.query.publicProssId);
    // }
  },
};
</script>

<style scoped>
.rich_box {
  width: 800px;
  border: 1px solid;
  border-color: #dadada;
  overflow-y: scroll;
  padding: 30px;
  margin: 0 auto;
  text-align: center;
}

.rich_box::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.rich_box::-webkit-scrollbar-button {
  display: none;
}

.rich_box::-webkit-scrollbar-track {
  background: transparent;
}

.rich_box::-webkit-scrollbar-track-piece {
  background-color: transparent;
}

.rich_box::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  cursor: pointer;
  border-radius: 4px;
}

.rich_box::-webkit-scrollbar-corner {
  display: none;
}

.rich_box::-webkit-resizer {
  display: none;
}

.rich_box img {
  width: 100%;
}

.training_course {
  margin: 0 auto;
}

.training_course_title {
  position: relative;
}

.training_course_title p {
  font-size: 20px;
  font-weight: bold;
  color: #0070c0;
  border-bottom: 3px solid #0070c0;
  padding: 12px 0;
}

.training_course_title .line {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 1px;
  background: #d8e5ef;
  z-index: -1;
}

.goSignUpClassInsort {
  margin-top: 16px;
}

.goSignUpClassInsort .goSignUpClass {
  font-size: 18px;
  padding: 10px 16px;
  background-color: #0078be;
  color: #ffffff;
  width: 110px;
  text-align: center;
}

.card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.el-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 50%;
  margin-top: 50px;
  margin-bottom: 200px;
}

.content {
  margin-top: 18px;
  width: 1200px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  min-height: 100vh !important;
}

.content .welfare_publicity_title {
  height: 54px;
}

.content .line2 {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 1px;
  background: #d8e5ef;
  z-index: -1;
}

.content .peixun-title {
  width: 250px;
  margin-left: 20px;
}

.content .gongyi-title {
  padding: 12px 0;
  border-bottom: 1px solid #d8e5ef;
  padding-bottom: 0px;
}

.content .gongyi-title .renzheng {
  font-size: 18px;
  font-weight: 400;
  color: #C30A1B;
}

.content .gongyi-title .line {
  margin-top: 12px;
  width: 130px;
  height: 3px;
  background: #0078be;
}

.content .son-menu {
  margin-top: 30px;
}

.content .son-menu .menu-item {
  padding: 18px 0px;
  padding-bottom: 15px;
  background: #F5F5F5;
  margin-top: 8px;
}

.content .son-menu .menu-item.active {
  background: #C30A1B;
  font-size: 20px;
  font-weight: bold;
}

.content .son-menu .menu-item .menu-up {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.content .son-menu .menu-item .menu-title {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}

.content .son-menu .menu-item .menu-title.active {
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
}

.content .son-menu .menu-item .en-title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d1d5d7;
  margin-top: 10px;
}

.content .son-menu .menu-item .icon {
  width: 20px;
  height: 20px;
}

.content .couser-module {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 60px;
  margin-top: 20px;
  min-height: 60vh;
}

.content .couser-module .course-list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.content .couser-module .course-list .item {
  width: 275px;
  margin-top: 30px;
  margin-right: 30px;
}

.content .couser-module .course-list .item .item-img {
  width: 275px;
  height: 160px;
}

.content .couser-module .course-list .item .img-title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-left: 10px;
}

.content .couser-module .course-list .item .title-view {
  width: 275px;
  padding: 20px 0;
  background: #FFFFFF;
  -webkit-box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.16);
  opacity: 0.5;
}

.content .couser-module .pagination {
  margin-top: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 100px;
}

.el-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 633px;
  margin-top: 50px;
  margin-bottom: 200px;
}

.pagination.el-pagination.is-background {
  margin-bottom: 0 !important;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #C30A1B;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/views/onlineRegistration/OnlineCourse.vue